import React from 'react';
import Card from '../../common/Card';
import Button from '../../common/Button';
import './styles.css';

/**
 * 用戶卡片組件
 * 用於顯示用戶信息
 * 
 * @param {Object} props - 組件屬性
 * @param {Object} props.user - 用戶對象
 * @param {Function} props.onEdit - 編輯回調
 * @param {Function} props.onDelete - 刪除回調
 * @returns {JSX.Element} 用戶卡片組件
 */
function UserCard({ user, onEdit, onDelete }) {
    // 獲取角色顯示文本
    const getRoleText = (role) => {
        switch (role) {
            case 'admin':
                return '管理員';
            case 'normal':
                return '普通用戶';
            default:
                return '未知角色';
        }
    };

    return (
        <Card className="user-card">
            <div className="user-card-content">
                <div className="user-card-info">
                    <h3 className="user-card-name">{user.username}</h3>
                    <div className="user-card-role">
                        <span className={`role-badge role-${user.role || 'normal'}`}>
                            {getRoleText(user.role)}
                        </span>
                    </div>
                    {user.lastLogin && (
                        <div className="user-card-last-login">
                            上次登入：{new Date(user.lastLogin).toLocaleString('zh-TW')}
                        </div>
                    )}
                </div>
                <div className="user-card-actions">
                    <Button
                        variant="secondary"
                        size="small"
                        onClick={() => onEdit(user)}
                    >
                        編輯
                    </Button>
                    <Button
                        variant="danger"
                        size="small"
                        onClick={() => onDelete(user.id)}
                    >
                        刪除
                    </Button>
                </div>
            </div>
        </Card>
    );
}

export default UserCard; 